import { Container } from './styles';

interface ReportCardProps {
  icon: string;
  title: string;
}

function ReportCard({ icon, title }: ReportCardProps) {
  return (
    <Container>
      <img src={icon} alt={title} />
      <div>
        <p>{title}</p>
      </div>
    </Container>
  );
}

export default ReportCard;
